import { Contractor as ContractorBaseModel } from "@components/modules/contractors/ContractorModel";
import { t } from "@lingui/macro";
import { BusinessFormEnum } from "@src/__generated__/urql-graphql";

export class Contractor extends ContractorBaseModel {
  get isVatPayerReadable(): string {
    return this.is_vat_payer ? t`Yes` : t`No`;
  }

  get businessFormReadable(): string {
    return this.business_form === BusinessFormEnum.Person
      ? t`Legal person`
      : t`Company`;
  }
}
